import { Injectable } from '@angular/core';
import { HttpHeaderService } from 'src/app/shared/service/http-header.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpClientAbstract } from 'src/app/shared/service/http-client-abstract';
import { Observable, BehaviorSubject, ReplaySubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PairSuitabilityFeedbackService extends HttpClientAbstract {
  submittedPair$ = new ReplaySubject<{
    ai_worker_id: string;
    ai_project_id: string;
    suitable: boolean;
  }>(20);

  constructor(header: HttpHeaderService, http: HttpClient) {
    super(header, http);
  }
  feedBack(
    workerAiId: string,
    projectAiId: string,
    suitable: boolean,
    page: string
  ): Observable<any> {
    const param = {
      ai_worker_id: workerAiId,
      ai_project_id: projectAiId,
      suitable: suitable,
      source_page: page
    };

    this.submittedPair$.next(param);
    return super.requestPost(
      'api/v1/action_log_for_pair_suitability_feedbacks',
      param
    );
  }
}
